// @file Vuex Store for showing a spinner dialog.
import { Module } from 'vuex'

interface SpinnerModalState {
  isOpen: boolean
}

const blankState = (): SpinnerModalState => ({
  isOpen: false,
})

const SpinnerModalModule: Module<SpinnerModalState, object> = {
  namespaced: true,
  state: blankState,
  mutations: {
    OPEN_MODAL(state): void {
      state.isOpen = true
    },
    CLOSE_MODAL(state): void {
      state.isOpen = false
    },
  },
  actions: {
    openSpinnerModal({ commit }): void {
      commit('OPEN_MODAL')
    },
    closeSpinnerModal({ commit }): void {
      commit('CLOSE_MODAL')
    },
  },
}

export default SpinnerModalModule
